window.addEventListener(
  "DOMContentLoaded",
  function () {
    const displayQustionBlock = document.getElementById("displayQuestions");
    // console.log(displayQustionBlock);

    function getQueryParam(param) {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    }

    var appid = getQueryParam("appid");
    var userid = getQueryParam("userid");
    if (!appid) {
      var appid = "demo";
      var userid = "demo";
    }

    var hostname = window.location.hostname;

    function setCookie(name, value, days) {
      let cookieString = name + "=" + encodeURIComponent(value) + ";";
      if (days) {
        let expirationDate = new Date();
        expirationDate.setTime(
          expirationDate.getTime() + days * 24 * 60 * 60 * 1000
        ); //one day

        cookieString += "expires=" + expirationDate.toUTCString() + ";";
      }
      cookieString += "path=/;";
      cookieString += "domain=" + hostname + ";";
      cookieString += "secure=true;"; // true on production
      cookieString += "samesite=Lax;";
      document.cookie = cookieString;
    }

    // setCookie("appid", appid, 1);
    // setCookie("userid", userid, 1);
    // setCookie("msisdn", userid, 1);

    function getCookieValue(key) {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(key + "=")) {
          return cookie.substring(key.length + 1);
        }
      }
      return null;
    }
    //spa_question start
    let score = 0;
    let answeredCount = 0;
    let questions = []; // To store fetched questions
    let correctAnswer = 0;

    const quizContainer = document.getElementById("displayQuestions");
    const yourScoreBox = document.getElementById("yourscore");
    const totalPointBox = document.getElementById("totalPoint");
    const questAnsweredBox = document.getElementById("questAnswered");
    const questCorrectAnsweredBox = document.getElementById(
      "questCorrectAnswered"
    );
    let thanksMsg = document.getElementById("thanksMsg");

    // Show the result container
    const resultcontainer = document.getElementById("resultcontainer");

    var resultMsgHtml = ` 
        <p class="result-message-line result_description" >
          There's always next time. New quiz next week.
        </p>
         `;

    let resultMsgBox = document.getElementById("resultMsg");

    resultMsgBox.innerHTML = resultMsgHtml;
    // questAnswered

    let totalQuestion = "";
    // document.getElementById("spa_question").innerHTML = "Loading...";

    var startDate = getQueryParam("startDate");
    var endDate = getQueryParam("endDate");

    if (startDate !== null && endDate !== null) {
      var questionUrl =
        "https://mtech.graphity.in/cms/api/quiz/ndtv?category=quiz&lang=english&size=7&startDate=" +
        startDate +
        "&endDate=" +
        endDate;
    } else {
      // var questionUrl = "./data.json";
      var questionUrl =
        "https://mtech.graphity.in/cms/api/quiz/ndtv?category=quiz&lang=english&size=7";
    }

    function fetchQuestions() {
      fetch(questionUrl)
        .then((response) => {
          // console.log(response);
          return response.json();
        })
        .then((data) => {
          questions = data;

          totalQuestion = questions.length;

          let shuffled = questions
            .map((value) => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);

          questions = shuffled;

          // document.getElementById("spa_ques_count").innerHTML = totalQuestion;
          // document.getElementById("totalqustion_probar").innerHTML = totalQuestion;

          displayQuestions(questions);
        });
    }

    function displayQuestions(questions) {
      quizContainer.innerHTML = ""; // Clear the container

      questions.forEach((question, index) => {
        let imagePath = question.image;
        let readMoreLink = question.url;
        let descriptionText = question.toolTip;

        if (imagePath === null || imagePath === undefined || imagePath === "") {
          imagePath = "./src/img/img1.png";
        }

        if (
          readMoreLink === null ||
          readMoreLink === undefined ||
          readMoreLink === ""
        ) {
          readMoreLink = "#";
        }

        if (
          descriptionText === null ||
          descriptionText === undefined ||
          descriptionText === ""
        ) {
          descriptionText =
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ";
        }

        const questionHtml = `
      <div class="quiz-question" id="question-${index + 1}">
        <span class="question-number">Q ${index + 1}/${questions.length}</span>
        <h2 class="question">${question.question}</h2>
        <div class="options">
          <button class="option" onclick="checkAnswer(this, '${
            question.correctAnswer === "A"
          }', ${index + 1})">
            ${question.optionA}
          </button>
          <button class="option" onclick="checkAnswer(this, '${
            question.correctAnswer === "B"
          }', ${index + 1})">
            ${question.optionB}
          </button>
          <button class="option" onclick="checkAnswer(this, '${
            question.correctAnswer === "C"
          }', ${index + 1})">
            ${question.optionC}
          </button>
          <button class="option" onclick="checkAnswer(this, '${
            question.correctAnswer === "D"
          }', ${index + 1})">
            ${question.optionD}
          </button>
        </div>
        <div class="info-container" style="display: none;">
          <div class="info-content">
            <div class="info-box">
              <img src="${imagePath}" alt="Image" class="info-image" />
            </div>
            <div class="info-text">
              <p>${descriptionText}</p>
              <p class="read-more">
                <a href="${readMoreLink}" target="_blank">Read More</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr class="separator" />
      `;

        quizContainer.insertAdjacentHTML("beforeend", questionHtml);
      });
    }
    function checkAnswer(button, isCorrect, questionNumber) {
      // Disable all buttons in the same question
      const options = button.parentElement.querySelectorAll("button");
      options.forEach((option) => {
        option.disabled = true;
      });

      // Add your answer checking logic here
      if (isCorrect === "true") {
        button.classList.add("correct");
        score += 5; // Add 5 points for the correct answer
        correctAnswer++;
      } else {
        button.classList.add("incorrect");
      }

      yourScoreBox.innerHTML = score;
      totalPointBox.innerHTML = score;
      // Update the score and answered count
      answeredCount++;
      questAnsweredBox.innerText = answeredCount;
      // Show the info container
      const infoContainer = button
        .closest(".quiz-question")
        .querySelector(".info-container");
      infoContainer.style.display = "block";

      if (questions.length == answeredCount) {
        document.getElementById("resultcontainer").style.display = "block";
        questCorrectAnsweredBox.innerHTML = correctAnswer;
      }

      if (score >= 0 && score <= 10) {
        var resultMsgHtml = `<p class="result-message-line result_description" >
          There's always next time. New quiz next week.
        </p>`;
        resultMsgBox.innerHTML = resultMsgHtml;
      } else if (score == totalQuestion * 5) {
        var resultMsgHtml = `<p class="result-message-line result_description" >
      You have aced the quiz like a true news whiz
    </p>    
    <p class="hasTag">
      Follow #NewsOnNDTV for the fastest updates, and sharpest reports.
    </p>`;

        resultMsgBox.innerHTML = resultMsgHtml;
        thanksMsg.innerHTML = "Congratulations!";
      } else if (score >= 15 && score <= 30) {
        var resultMsgHtml = `<p class="result-message-line result_description" >
      Replay or come back next week for a fresh quiz.
    </p>
    <p class="hasTag">
      Follow #NewsOnNDTV to catch all the news.
    </p>`;

        resultMsgBox.innerHTML = resultMsgHtml;
        thanksMsg.innerHTML = "Almost aced it!";
      }
    }

    window.checkAnswer = checkAnswer;

    function restartGame() {
      // Reset score and answered count
      score = 0;
      answeredCount = 0;
      correctAnswer = 0;

      // Update the display
      yourScoreBox.innerHTML = score;
      totalPointBox.innerHTML = score;

      questAnsweredBox.innerText = answeredCount;

      let shuffled = questions
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);

      // console.log(shuffled);

      questions = shuffled;

      // Redisplay the questions
      displayQuestions(questions);

      document.getElementById("resultcontainer").style.display = "none";
    }

    window.restartGame = restartGame;

    fetchQuestions();
  },
  false
);
